import React, { useState, useEffect, useRef } from "react";
import Utils from "../../streaming/Util";
import RTMConst from "../../constants/Rtmconstants";
import Const from "../../constants/Constants";
import classnames from "classnames";
import axios from "axios";
import {Emoji} from "./Emoji";
import {ChatDropDown} from "./ChatDropDown";
import {ChatLeft} from "./ChatLeft";
import { toast, ToastContainer, Flip } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
var $ = window.$ || {}

export default (props) => {

  const [currentUserData] = useState(JSON.parse(localStorage.getItem('userData')));
  const [peerId, setPeerId] = useState(null);
  const [current_conversation, setConversation] = useState('channel');
  const [chats, setChat] = useState([]);
  const [chatMsg, setChatMsg] = useState('');
  const [messageCounter, setMessageCounter] = useState(0);
  const [showMessages, setShowMessages] = useState(false);
  const [sessionUsers, setSessionUsers] = useState(JSON.parse(localStorage.getItem('tempUsers')));
  const [showImageUpload, setShowImageUpload] = useState(true);
  const [peerName, setPeerName] = useState('');
  const [sessionChats, setSessionChats] = useState({sessionId: 0, messages: [], unreadCount: 0});
  const [lastChatTime, setLastChatTime] = useState(null);
  const [userleft, setUserLeft] = useState([]);
  const [firstOpen, setFirstOpen] = useState(false);
  const [remoteMessageType, setRemoteMessageType] = useState('text');
  const [remoteMessageCounter, setRemoteMessageCounter] = useState(0);
  const sep = '~@$';
  const audio = new Audio('./audio/chat.mp3');
  const ref = useRef(null)
  const messageInputRef = useRef(null);

	useEffect(() => {
      let sessionUserChats = JSON.parse(localStorage.getItem('chats'));
    	if ( sessionUserChats !== null && sessionUserChats.sessionId == currentUserData.sessionData.id )
    	{
          setSessionChats(oldState => ({
            ...oldState,
            sessionId: currentUserData.sessionData.id,
            messages : sessionUserChats.messages,
            unreadCount: sessionUserChats.unreadCount
          }));

          updateChatList(sessionUserChats.messages, sessionUserChats.unreadCount);
    	}
    	else if ( sessionUserChats !== null && currentUserData.sessionData && currentUserData.sessionData.id && sessionUserChats.sessionId != currentUserData.sessionData.id )
    	{
				localStorage.removeItem('chats');

          setSessionChats(oldState => ({
            ...oldState,
            sessionId: currentUserData.sessionData.id
          }));
    	}
    	else
    	{
    			setSessionChats(oldState => ({
            ...oldState,
            sessionId: currentUserData.sessionData.id
          }));
    	}

      if ( currentUserData.userType == 2 )
      {
          if ( window['sendMessageToChannel'] )
		  {
			window['sendMessageToChannel'](RTMConst.CHAT_SYNC + sep);
		  }
          setShowImageUpload(false);
      }

      document.getElementById('chat-msg-container').addEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
      updateLocalStorage();
  }, [sessionChats]);

  useEffect(() => {
      if (chatMsg != '') 
      {
          sendMessage(chatMsg, remoteMessageType);
          setChatMsg('');
      }
  }, [remoteMessageCounter]);

  useEffect(() => {
      function handleClickOutside(event) {
          if (ref.current && !ref.current.contains(event.target)) {
              $('#emojiContainer').removeClass('show');
          }
      }

      document.addEventListener("mousedown", handleClickOutside);
  }, [ref]);
  useEffect(() => {
    props.onChatCountUpdated(messageCounter);
  }, [messageCounter]);

  const handleScroll = () => {
      let chatMsgContainer = $('.chat-msg-container');
    
      if (chatMsgContainer[0].offsetHeight + Math.round(chatMsgContainer[0].scrollTop) == chatMsgContainer[0].scrollHeight) 
      {
          setSessionChats(oldState => ({
            ...oldState,
            unreadCount: 0
          }));
          setMessageCounter(0);
      }
  }

  const updateChatList = (chats, unreadCount) => {
    setChat([...chats]);

    if (chats.length > 0) 
    {
        setLastChatTime(chats[chats.length-1].time);
    }

    setMessageCounter(unreadCount);
  }

  const handleChange = (event) => setChatMsg(event.target.value);

  const keypress = (e) => {
    if (e.key === 'Enter' && chatMsg != '') {
      e.preventDefault();
      doSendMsg();
    }
  }

  const doSendMsg = () => {
    if ( chatMsg != '' ) 
    {
      sendMessage(chatMsg);
      setChatMsg('');
    }
  }

  const incrementCounter = (bottom=true) => {
      if ( !showMessages || !bottom )
      {          
          setMessageCounter(messageCounter + 1);
          sessionChats.unreadCount++;
      }
  }

  const updateChats = (msg_item) => {
      let newArr = sessionChats.messages;
      newArr.push(msg_item);

      setSessionChats(oldState => ({
        ...oldState,
        messages: newArr
      }));

      let chatMsgContainer = $('.chat-msg-container');

      if ( msg_item.type == Const.MESSAGE.RECEIVE )
      {
          console.error(chatMsgContainer[0].offsetHeight, chatMsgContainer[0].scrollTop, chatMsgContainer[0].scrollHeight);
          if (chatMsgContainer[0].offsetHeight + Math.round(chatMsgContainer[0].scrollTop) < chatMsgContainer[0].scrollHeight) 
          {
              incrementCounter(false);
              setSessionChats(oldState => ({
                ...oldState,
                unreadCount: sessionChats.unreadCount++
              }));
          }
          else
          {
              setTimeout(() => {
                  chatMsgContainer.scrollTop(chatMsgContainer[0].scrollHeight);
              }, 10);
          }
      }

      setChat([...chats, msg_item]);

      if ( msg_item.type == Const.MESSAGE.SEND && messageCounter == 0 ) 
      {
          setTimeout(() => {
              chatMsgContainer.scrollTop(chatMsgContainer[0].scrollHeight);
          }, 10);
      }
  }

  const sendMessage = (message, messageType = 'text') => {
		let msg = RTMConst.CHAT + sep + (message) + sep + messageType;

    if (current_conversation === 'p2p') {
    	window['globalRTM'](peerId, msg);
      window['globalRTM']('RM-'+peerId, msg);

      msg = msg + sep + peerId;
      window['globalRTM']('RM-'+currentUserData.email, msg);
    } else {
    	window['sendMessageToChannel'](msg);
    }

    var userImage = currentUserData.image;

    if ( !currentUserData.image || currentUserData.image == 'null' || ( currentUserData.image !== '' && currentUserData.image.indexOf('.s3') == -1 ) )
    {
        userImage = './images/user_avatar.svg';
    }

    let msg_item = { userId: currentUserData.id, name: peerName, image: userImage, message: message, conversation: current_conversation, type: Const.MESSAGE.SEND, messageType: messageType, time: new Date().getTime(), toUserEmail: current_conversation == 'p2p' ? peerId : '' };
    updateChats(msg_item);
  }

  const updateLocalStorage = () => {
	if ( sessionChats['sessionId'] )
		{
			localStorage.setItem('chats', JSON.stringify(sessionChats));
		}
  }

  const onReceiveMessage = (userDetails, message, conversation, messageType, receiverName='') => {
    incrementCounter();

    let name = ''
    if (receiverName !== '') 
    {
        name = receiverName;
    }
    else
    {
        name = userDetails.email == currentUserData.email ? '' : userDetails.firstName
    }

    let msg_item = { userId: userDetails.id, name: name, image: userDetails.image, message: message, conversation: conversation, type: userDetails.email == currentUserData.email ? Const.MESSAGE.SEND : Const.MESSAGE.RECEIVE, messageType: messageType, time: new Date().getTime() };
    updateChats(msg_item);
    audio.play();
  }
  window.onReceiveMessage = onReceiveMessage;

  const emojiSelected = (e) => {
    setChatMsg(chatMsg + e.target.innerHTML);
  }

  const closeEmojiContainer = (e) => {
    $('#emojiContainer').removeClass('show');
  }

  const handleChangeOption = (event) => {
      let peerId = event.target.value;

	    setConversation($('.chat-option option:selected').attr('msgtype'));
      setPeerId(peerId);
      setPeerName($('.chat-option option:selected').attr('name'));

      if ( currentUserData.userType == 2 ) 
      {
          if ( peerId == currentUserData.sessionData.hostEmail ) 
          {
              setShowImageUpload(true);
          }
          else
          {
              setShowImageUpload(false);
          }
      }
	}

  const updateOnMemberLeft = (userEmail) => {
      /*if ( peerId == userEmail )
      {
          setConversation('channel');
          setPeerId('');
          setPeerName('');
      }

      if ( currentUserData.userType == 2 ) 
      {
          setShowImageUpload(false);
      }

      setUserLeft([...userleft, 1]);*/
  }
  window.onMemberLeft = updateOnMemberLeft;

  const showChat = (state) => {
    if (state) 
    {
        setShowMessages(true);
        window.$('.chat-wrapper').css({display:"block"});
        messageInputRef.current.focus();

        if (firstOpen === false) 
        {
            sessionChats.unreadCount = 0;
            updateLocalStorage();
            setFirstOpen(true);
            setMessageCounter(0);

            let chatMsgContainer = $('.chat-msg-container');
            chatMsgContainer.scrollTop(chatMsgContainer[0].scrollHeight);
        }

        let chatMsgContainer = $('.chat-msg-container');
        if ( chatMsgContainer[0].scrollHeight == 0 || 
              chatMsgContainer[0].offsetHeight + chatMsgContainer[0].scrollTop == chatMsgContainer[0].scrollHeight
            ) 
        {
            setMessageCounter(0);
            sessionChats.unreadCount = 0;
            updateLocalStorage();
        }
    }
    else
    {
        setShowMessages(false);
        window.$('.chat-wrapper').css({display:"none"});
    }
  }
  window.chatWindow = showChat;

  const uploadChatImage = (e) => {
    
    let file = e.target.files[0];

    if ( file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg' )
    {
        var fr = new FileReader();
        fr.onload = function(e)
        {          
          const data = new FormData();
          data.append('file', file);
		  data.append('chatFile', 1);
          
		  let token = currentUserData.token;
		  axios.defaults.headers.common['Authorization'] = token;
		  
          axios.post(process.env.REACT_APP_API_URL+"/api/v1/upload/upload", data)
          .then(res => {
            sendMessage(res.data.responseData.file, 'image');
          }).catch(err =>{ 
            toast.error('Something went wrong. Please try again', {
              hideProgressBar: true
            });
          });
        };

        fr.readAsDataURL(file);
    }
    else
    {
        toast.error('Only .png and .jpeg extensions are supported', {
          hideProgressBar: true
        });
    }

    e.target.value = null;
  }
  
  const getSessionUsers = () => {
    console.log('users to chat---', JSON.parse(localStorage.getItem('tempUsers')));
	setSessionUsers(JSON.parse(localStorage.getItem('tempUsers')));
  }

  window.getSessionUsers = getSessionUsers;
	
  const syncChat = (chatData) => {
      if (lastChatTime !== null && new Date(chatData.time) <= new Date(lastChatTime)) 
      {
          return;
      }

      incrementCounter();
      
      let msg_item = { userId: chatData.userId, name: currentUserData.sessionData.hostFirstName, image: chatData.image, message: chatData.message, conversation: chatData.conversation, type: Const.MESSAGE.RECEIVE, messageType: chatData.messageType, time: chatData.time };
      updateChats(msg_item);
  }
  window.syncChat = syncChat;

  const resetBadgeCounter = () => {
      setMessageCounter(0);
      sessionChats.unreadCount = 0;
      updateLocalStorage();

      let chatMsgContainer = $('.chat-msg-container');
      chatMsgContainer.animate({ scrollTop: chatMsgContainer[0].scrollHeight}, 1000);
  }

  return (
      <div className={props.className}>
          <div className="chat-wrapper">
            <div className="chat-header">
                <h6>Let's Chat - Online</h6>
                <button type="button" className="close white close-btn1" data-dismiss="modal" onClick={showChat.bind(null, false)}>×</button>
            </div>
              <div className="chat-body">
                <div className="chat-msg-container" id="chat-msg-container">
                  <div className={classnames("unread-messages ", {'d-none': messageCounter > 0 ? false : true })} onClick={() => resetBadgeCounter()}>
                    <span>{messageCounter > 0 ? (messageCounter <= 9 ? messageCounter : 9) : ''}<span className={classnames({ 'd-none': messageCounter > 9 ? false : true})}>+</span></span> new messages
                  </div>
                  <ul className="chat-messages">
                    { chats.map((chat, key) => 
                        <li className={classnames("message  clearfix", { 'right': chat.type == Const.MESSAGE.SEND, 'left': chat.type == Const.MESSAGE.RECEIVE })} key={key}>
                            <div className={classnames("headermsg")}>
                                <div className={classnames("to")}>
                                {chat.type == Const.MESSAGE.SEND
                                  ? <div style={{color: "#20bbe1"}}><span style={{color: "#fff"}}>Me</span> to <span style={{color: "#20bbe1"}}>{chat.name != '' ? chat.name : 'Everyone'}</span></div>
                                  : <div style={{color: "#20bbe1"}}><span style={{color: "#fff"}}>{chat.name} {chat.userId == currentUserData.sessionData.hostId ? '(Instructor)' : ''}</span> to <span style={{color: "#20bbe1"}}>{chat.conversation == 'p2p' ? 'Me (Direct)' : 'Everyone'}</span></div>
                                }
                                </div>
                                <img src={(chat.image != '' && chat.image != null) ? chat.image : './images/user_avatar.svg'} />
                            </div>                                             
                            <div className="bubble">
                                {chat.messageType == 'text'
                                  ? <div className="text-align-start" dangerouslySetInnerHTML={{ __html: Utils.parseString(chat.message) }} />
                                  : <>
                                      <img src={chat.message} onClick={(e)=>{window.open(chat.message + '?chatfile',"_blank")}} className="chat-file-link" />
                                      <a href={chat.message + '?chatfile'} target="_blank" title={Utils.getFilenameFromUrl(chat.message)}>
                                        {Utils.getFilenameFromUrl(chat.message, false)}
                                      </a>
                                    </>
                                }
                            </div>
                            <div className={classnames("ch_time")}>{Utils.getChatTime(chat.time)}</div>
                        </li>
                    )}
                    {/*<ChatLeft userleft={userleft} />*/}
                  </ul>
                </div>
                <div className="chat_user_action">
                  <div className="to">
                    <div style={{color: "#fff"}}>To: 
                    </div>
                    <ChatDropDown 
                      sessionUsers={sessionUsers} 
                      getSessionUsers={getSessionUsers} 
                      currentUserData={currentUserData} 
                      handleChangeOption={handleChangeOption}
                    />
                  </div>
                  <div className="chat_assets">
					<div className="chat-emoji collapse" id="emojiContainer" ref={ref}>
						<Emoji emojiSelected={emojiSelected} closeEmojiContainer={closeEmojiContainer} />
					  </div>
                    <div className={classnames("custom-file-session", { 'd-none': !showImageUpload })}>
                      <label className="chat_inputlabel" htmlFor="getFile"></label>
                      <input id="getFile" type="file" style={{display: "none"}} name="file" onChange={ (e) => { uploadChatImage(e) }} />
                    </div>
                    <textarea 
                      value={chatMsg} 
                      placeholder="Message..." 
                      rows="3" 
                      className="form-textarea typing-area" 
                      onChange={handleChange}
                      onKeyPress={keypress}
                      ref={messageInputRef} 
                    />

                  <img className="chat-smiley" src="./images/chat/emotion.svg" data-toggle="collapse" href="#emojiContainer"></img>
                  <img className="chat-send" src="./images/chat/send.svg" onClick={doSendMsg} ></img>

                  </div>
                  </div>
              </div>
          </div>
          <ToastContainer newestOnTop={false} transition={Flip} />
      </div>
    );

}